import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-2xl bg-primary/8 dark:bg-primary/15", className)}
      {...props}
    />
  )
}

export { Skeleton }

